import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from 'components/Loader'
import qs from 'query-string'
import { useLocation } from 'react-router-dom'
import { useAppContext } from 'context/app-context'
import { createGeeksterUserWithUnilogin } from 'services/user-services'

export interface UniLoginReply {
    user: string
    timestamp: string
    auth: string
    subscribeNewsLetter: boolean
}

export function useUniLoginReply<T extends UniLoginReply>(): T | undefined {
    const { search } = useLocation()
    const ps = qs.parse(search) as unknown as T

    if (!ps.user || !ps.timestamp || !ps.auth) {
        return undefined
    }

    return ps
}

let hasAlreadyRun = false
export const Complete: React.FC = () => {
    const navigate = useNavigate()

  const { handleMessage } = useAppContext()

  const uniLoginReply = useUniLoginReply()

  
  useEffect(() => {
    if (!hasAlreadyRun && uniLoginReply.subscribeNewsLetter) {
        hasAlreadyRun = true;
       (async () => {
        try {
            await createGeeksterUserWithUnilogin({uniLoginUsername: uniLoginReply?.user, subscribeNewsLetter: uniLoginReply.subscribeNewsLetter})
            handleMessage('Your account has been created!', 'success')
        } catch (error) {
            handleMessage('Whoops! There was an error.', 'error')
        } finally {
            navigate("/authentication/sign-in")
        }
       })()
    }
    if (!uniLoginReply) {
        handleMessage('Whoops! There was an error.', 'error')
        return navigate("/authentication/sign-in")
    }
    }, [uniLoginReply, navigate, handleMessage])

    return <Loader/>
}
